module.exports = __webpack_public_path__ + "img/member_shopping_online_icon_ycq.f3671c60.png";